"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Block["default"];
  }
});
var _Block = _interopRequireDefault(require("./Block"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }